import api from '../../api/index';
import router from '../../router';

export default {
  namespaced: true,
  state     : {
    users_employees_table: {
      content: {
        pagination: {
          'rowsPerPage': 10,
          'sortBy'     : 'name'[1],
          'totalItems' : 10,
          'descending' : 'desc',
        },
        headers: [
          {text: 'id', value: 'id'},
          {text: 'Имя', value: 'name'},
          {text: 'Достижение', value: 'achievment'},
          {text: 'Организация', value: 'organization'},
          // {text: 'Специализация', value: 'specialization'},
          {text: 'Роль на портале', value: 'role'},
          {text: 'Дата добавления', value: 'date'},
        ],
        body: [],
      },
    },
    search_string    : '',
    users_pages      : 0,
    page             : 1,
    org_filter       : '',
    role_filter      : '',
    speciality_filter: '',
    showed_filter    : false,
    users_filters    : undefined,
  },
  getters: {
    page                 : ({page}) => page,
    users_pages          : ({users_pages}) => users_pages,
    search_string        : ({search_string}) => search_string,
    users_filters        : ({users_filters}) => users_filters,
    showed_filter        : ({showed_filter}) => showed_filter,
    org_filter           : ({org_filter}) => org_filter,
    role_filter          : ({role_filter}) => role_filter,
    speciality_filter    : ({speciality_filter}) => speciality_filter,
    users_employees_table: ({users_employees_table}) => {
      const pagination = localStorage.getItem('paginationValueUsers') || 10;
      users_employees_table.content.pagination.rowsPerPage = pagination;
      return users_employees_table;
    },
    get_id_by_organization: ({users_filters}) => (role) => {
      let answer = {};

      if (users_filters !== undefined) {
        answer = users_filters.organizations.find((item) => {
          return item.text === role;
        });
      }

      return answer;
    },
    get_id_by_role: ({users_filters}) => (role) => {
      let answer = {};

      if (users_filters !== undefined) {
        answer = users_filters.roles.find((item) => {
          return item.text === role;
        });
      }

      return answer;
    },
    get_role_by_id: ({users_filters}) => (id) => {
      let answer = {};

      if (users_filters !== undefined) {
        answer = users_filters.roles.find((item) => {
          return parseInt(item.id) === id;
        });
      }

      return answer;
    },
    // table_employees_filtered: ({org_filter, role_filter, speciality_filter, users_employees_table}) => {
    //   let table = users_employees_table.content.body;
    //   if (org_filter) {
    //     table = table.filter((item)=>item.organization == org_filter);
    //   }
    //   if (role_filter) {
    //     table = table.filter((item)=>item.role == role_filter);
    //   }
    //   if (speciality_filter) {
    //     table = table.filter((item)=>item.specialization == speciality_filter);
    //   }
    //   return table;
    // },
  },
  mutations: {
    TOGGLE_FILTER(state) {
      state.showed_filter = !state.showed_filter;
    },
    RESET_EMPLOYEES_FILTERES(state) {
      state.org_filter = '';
      state.role_filter = '';
      state.speciality_filter = '';
      state.users_employees_table.content.pagination.sortBy = '';
      state.users_employees_table.content.pagination.descending = '';
    },
    SET_EMPLOYEES_PAGINATION(state, value) {
      state.users_employees_table.content.pagination = value;
    },
    SHOW_NUMBER(state, selected) {
      let selectedTable = state.users_employees_table.content;

      if (selected=='Показывать по 10') {
        selectedTable.pagination.rowsPerPage = 10;
      } else if (selected=='Показывать по 25') {
        selectedTable.pagination.rowsPerPage = 25;
      } else if (selected=='Показывать по 50') {
        selectedTable.pagination.rowsPerPage = 50;
      } else if (selected=='Показывать по 100') {
        selectedTable.pagination.rowsPerPage = 100;
      }
    },
    SET_PAGE(state, value) {
      state.page = value;
    },
    SEARCH_EMPLOYEE(state, value) {
      state.search_string = value;
    },
    SET_ORG_FILTER(state, value) {
      state.org_filter = value;
    },
    SET_ROLE_FILTER(state, value) {
      state.role_filter = value;
    },
    SET_SPECIALITY_FILTER(state, value) {
      state.speciality_filter = value;
    },
    SET_PAGES_COUNT(state, value) {
      state.users_pages = value;
    },
    // SET_TABLE(state, obj) {
    //   let {table, value} = obj;
    //   let selectedTable = state.tables.find((object)=> object.name === table.name);
    //   selectedTable.content.items = value;
    //   selectedTable.content.totalItems = value.length;
    // },
    CHANGE_EMPLOYEES_SORT(state, column) {
      let selectedTable = state.users_employees_table.content;
      if (selectedTable.pagination.sortBy === column) {
        selectedTable.pagination.descending = !selectedTable.pagination.descending;
      } else {
        selectedTable.pagination.sortBy = column;
        selectedTable.pagination.descending = false;
      }
    },
    ADD_USER(state, user) {
      state.users_employees_table.content.body.push(user);
    },
    SET_USERS(state, value) {
      if (value) {
        state.users_employees_table.content.body = value;
        state.users_employees_table.content.body.forEach((x) => {
          x.date = x.date * 1000;
        });
      } else {
        state.users_employees_table.content.body = [];
      }
    },
    SET_USERS_FILTERS(state, value) {
      state.users_filters = value;
    },
    CHANGE_USERS_FILTERS(state, value) {
      state.users_filters = value;
    },
  },
  actions: {
    async accept_new_user({commit, getters, rootGetters}, user) {
      let {users_filters} = getters;
      let request_id = rootGetters['users/requests/request_id'];
      let user_id = user.id ? user.id : request_id;
      let organization = typeof user.organization == 'number' ? users_filters.organizations.find((item)=>item.id==user.organization).text : user.organization;
      let role = typeof user.role == 'number' ? users_filters.roles.find((item)=>item.id==user.role).text : user.role;
      let specialization = typeof user.specialization == 'number' ? users_filters.specializations.find((item)=>item.id==user.specialization).text : user.specialization;

      let user_table = {
        id            : user_id,
        external      : user.external,
        name          : ['-', `${user.last_name} ${user.name}`],
        achievement   : ['/upload/iblock/3a8/3a84b17fb1feadb1ecf6592ab26f2607.png', 'Новичок'],
        organization  : organization,
        specialization: specialization,
        role          : role,
        date          : new Date().getTime(),
      };
      try {
        await api.user.activate_user(user_id);
        commit('users/modals/CLOSE_MODAL', 'accept_request', {root: true});
        commit('ADD_USER', user_table);
        commit('users/requests/REMOVE_REQUEST', {request: user_id, type: 'user'}, {root: true});
      } catch (err) {
        if (err.message.indexOf('401')!=-1) {
          router.push({name: 'auth'});
          localStorage.clear();
        }
      }
    },
    async get_users_filters({commit}) {
      try {
        let answer = await api.user.users_filters();
        commit('CHANGE_USERS_FILTERS', answer.data);
      } catch (err) {
        if (err.message.indexOf('401')!=-1) {
          router.push({name: 'auth'});
          localStorage.clear();
        }
      }
    },
    async decline_new_user({commit}, user) {
      try {
        await api.user.decline_user(user.id);
        commit('users/modals/CLOSE_MODAL', 'accept_request', {root: true});
        commit('users/requests/REMOVE_REQUEST', {request: user.id, type: 'user'}, {root: true});
      } catch (err) {
        if (err.message.indexOf('401')!=-1) {
          router.push({name: 'auth'});
          localStorage.clear();
        }
      }
    },
    async update_users({state, dispatch}, inject = {}) {
      let pagination = localStorage.getItem('paginationValueUsers') || 10;
      let obj = Object.assign({
        page_size   : pagination,
        page_num    : 1,
        organization: state.org_filter,
        role        : state.role_filter,
        spec        : state.speciality_filter,
        name        : state.search_string,
      }, inject);

      await dispatch('get_users', obj);
    },
    async get_users({commit, state}, obj) {
      let sortBy = state.users_employees_table.content.pagination.sortBy;
      let sortOrder = state.users_employees_table.content.pagination.descending ? 'desc' : 'asc';

      try {
        let users = await api.user.get_users(obj.page_size, obj.page_num, obj.organization, obj.role, obj.spec, obj.name, sortBy, sortOrder);
        let get_filters = await api.user.users_filters();
        commit('SET_USERS', users.data.content);
        commit('SET_PAGES_COUNT', users.data.page_count);
        commit('SET_USERS_FILTERS', get_filters.data);
      } catch (err) {
        if (err.message.indexOf('401')!=-1) {
          router.push({name: 'auth'});
          localStorage.clear();
        }
      }
    },
    async add_new_user({commit}, obj) {
      try {
        let add_user = await api.user.add_user(obj);
        commit('users/requests/SET_REQUEST_ID', add_user.data.id, {root: true});
        commit('users/modals/CLOSE_MODAL', 'add_user', {root: true});
      } catch (err) {
        if (err.message.indexOf('401')!=-1) {
          router.push({name: 'auth'});
          localStorage.clear();
        } else {
          throw 'email exist';
        }
      }
    },
  },
};
